<template>
  <div>
    <el-form size="mini" class="main-table-filter" ref="clueForm" :model="form" label-width="180px" label-position="right" style="padding:16px;">
      <el-row style="margin-bottom: 10px;" :gutter="20">
        <el-col :span="8">
          <el-form-item prop="client_name">
            <template #label>
              <div class="form-title">客户名称：</div>
            </template>
            <el-select ref="clientNameRef" filterable clearable class="form-select" v-model="form.client_name" @change="(e)=>mutuliSelectChange(e,'client_name')" placeholder="全部客户">
              <el-option label="全部客户" value="all"></el-option>
              <el-option v-for="client_name_item in client_name_options" :label="client_name_item" :value="client_name_item"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="client_manager">
            <template #label>
              <div class="form-title">客户经理：</div>
            </template>
            <el-select class="form-select" filterable multiple v-model="form.client_manager" @change="(e)=>mutuliSelectChange(e,'client_manager')" placeholder="全部客户经理">
              <el-option label="全部客户经理" value="all"></el-option>
              <el-option v-for="item in ClueOption.client_manager" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="pre_sale">
            <template #label>
              <div class="form-title">售前介入：</div>
            </template>
            <el-radio-group v-model="form.pre_sale">
              <el-radio-button label="">全部</el-radio-button>
              <el-radio-button label="是">是</el-radio-button>
              <el-radio-button label="否">否</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <div v-show="showMore">
        <el-row style="margin-bottom: 10px;" :gutter="20">
          <el-col :span="8">
            <el-form-item prop="clue_status">
              <template #label>
                <div class="form-title">商机状态：</div>
              </template>
              <el-select filterable multiple class="form-select" v-model="form.clue_status" @change="(e)=>mutuliSelectChange(e,'clue_status')" placeholder="全部状态">
                <el-option label="全部" value="all"></el-option>
                <el-option v-for="item in clue_status_tabs" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="quotation_type">
              <template #label>
                <div class="form-title">业务类型和计价类型：</div>
              </template>
              <el-cascader
                  placeholder="请选择业务类型或计价类型"
                  class="form-select"
                  clearable
                  :show-all-levels="false"
                  v-model="quotation_type"
                  @change="quotationTypeChange"
                  :options="ClueOption.business_type"
                  :props="{ multiple: true }"
              ></el-cascader>
<!--              <el-select filterable class="form-select" v-model="form.quotation_type" placeholder="请选择业务类型或计价类型" @change="getBusinessTypeByQuoationType">-->
<!--                <el-option v-for="item in ClueOption.quotation_type_map" :label="item.quotation_type" :value="item.quotation_type"></el-option>-->
<!--              </el-select>-->
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item prop="quotation_type">
              <template #label>
                <div class="form-title">创建时间：</div>
              </template>
<!--              <el-date-picker-->
<!--                  v-model="form.create_time"-->
<!--                  type="daterange"-->
<!--                  unlink-panels-->
<!--                  value-format="yyyy-MM-dd"-->
<!--                  range-separator="至"-->
<!--                  start-placeholder="开始日期"-->
<!--                  end-placeholder="结束日期">-->
<!--              </el-date-picker>-->
              <CustomDateAreaPicker :default-start="form.create_time.start" :default-end="form.create_time.end" @dateAreaChange="dateAreaChange"/>

            </el-form-item>
          </el-col>

        </el-row>
        <el-row style="margin-bottom: 10px;" :gutter="20">
          <el-col :span="8">
            <el-form-item prop="success_rate">
              <template #label>
                <div class="form-title">成功率：</div>
              </template>
              <el-select filterable multiple class="form-select" @change="(e)=>mutuliSelectChange(e,'success_rate')" v-model="form.success_rate">
                <el-option label="全部" value="all"></el-option>
                <el-option v-for="item in success_rate_tabs" :label="item.label" :value="item.label"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="pre_sale_principal">
              <template #label>
                <div class="form-title">售前负责人：</div>
              </template>
              <el-select filterable multiple class="form-select" @change="(e)=>mutuliSelectChange(e,'pre_sale_principal')" v-model="form.pre_sale_principal">
                <el-option label="全部" value="all"></el-option>
                <el-option v-for="item in ClueOption.pre_sale_principal" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item prop="clue_status">
              <template #label>
                <div class="form-title">商机阶段：</div>
              </template>
              <el-select filterable multiple class="form-select" v-model="form.clue_stage" @change="(e)=>mutuliSelectChange(e,'clue_stage')" placeholder="全部">
                <el-option label="全部" value="all"></el-option>
                <el-option v-for="item in clue_stage_tabs" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="clue_status">
              <template #label>
                <div class="form-title">更新时间：</div>
              </template>
              <el-select filterable class="form-select" v-model="form.clue_update_time" @change="(e)=>mutuliSelectChange(e,'clue_update_time')" placeholder="全部">
                <el-option label="全部" value="all"></el-option>
                <el-option v-for="item in clue_update_time_tabs" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div v-show="!showMore" @click="showMore=!showMore" style="font-size:12px;width:100px;cursor: pointer;color:#409eff;text-align:center;margin-top:10px;position: absolute;left:calc(50% - 50px);">更多筛选条件<i class="el-icon-arrow-down"></i></div>
      <div v-show="showMore" @click="showMore=!showMore" style="font-size:12px;width:100px;cursor: pointer;color:#409eff;text-align:center;margin-top:10px;position: absolute;left:calc(50% - 50px);">收起<i class="el-icon-arrow-up"></i></div>


      <el-form-item style="display: flex;justify-content: end;">
        <el-button :loading="loading" type="" @click="cleanSubmit">重置条件</el-button>
        <el-button :loading="loading" type="primary" @click="onSubmit">查询</el-button>
      </el-form-item>

    </el-form>

  </div>
</template>

<script>
import {addClue, editClueInfo, getClueOption} from "@/api/api";
import {clue_status_tabs} from "@/config/index"
import CustomDateAreaPicker from "@/component/Performance/topTool/CustomDateAreaPicker";

export default {
  name: "MainTableFilter",
  components:{
    CustomDateAreaPicker
  },
  data() {
    return {
      dialogFormVisible: false,
      addClientDialogVisble: false,
      inputClientName:"",
      refreshId:0,
      quotation_type:[],
      showMore:false,
      client_name_options:[],
      ClueOption:{
        "client_manager": [],
        "client_name": [],
        "pre_sale_principal":[],
        quotation_type_map:[]
      },
      success_rate_tabs:[
        {
          label:"高"
        },
        {
          label:"中"
        },
        {
          label:"低"
        }
      ],
      clue_status_tabs:clue_status_tabs,
      clue_stage_tabs: ['进行中', '已关闭'],
      clue_update_time_tabs: [
        { label: '近7日未更新', value: '7-gt' },
        { label: '近15日未更新', value: '15-gt' },
        { label: '近7日更新', value: '7-lt' },
        { label: '近15日更新', value: '15-lt' },
      ],
      initForm:{
        "create_time": {
          "start":"",
          "end":""
        },
        "clue_status": [],
        "client_name": "",
        "quotation_type": [],
        "client_manager": [],
        "success_rate": [],
        "pre_sale": "",
        "pre_sale_principal": []
      },
      form: {
        "create_time": {
          "start":"",
          "end":""
        },
        "clue_status": [],
        "client_name": "",
        "quotation_type": [],
        "client_manager": [],
        "success_rate": [],
        "pre_sale": "",
        "pre_sale_principal": [],
        "clue_stage": ['进行中'],
        "clue_update_time": ""
      },

      hiddenQuotationTypeTips:false,

      loading:false,
      filterCond:[]
    }
  },
  mounted() {
    this.getClientNameList()
    this.onSubmit()
  },
  watch:{
    '$store.state.updateClientList'(newVal){
      console.log('updateClientList变化2')
      this.getClientNameList()
    }
  },
  methods:{
    dateAreaChange(val){
      console.log('dateAreaChange', val)
      this.form.create_time.start = val[0].value
      this.form.create_time.end = val[1].value
    },
    handleOninput(value){
      let str = value;
      let len1 = str.substr(0, 1);
      let len2 = str.substr(1, 1);
      //如果第⼀位是0，第⼆位不是点，就⽤数字把点替换掉
      if (str.length > 1 && len1 == 0 && len2 != ".") {
        str = str.substr(1, 1);
      }
      //第⼀位不能是.
      if (len1 == ".") {
        str = "";
      }
      if (len1 == "+") {
        str = "";
      }
      if (len1 == "-") {
        str = "";
      }
      //限制只能输⼊⼀个⼩数点
      if (str.indexOf(".") != -1) {
        let str_ = str.substr(str.indexOf(".") + 1);
        if (str_.indexOf(".") != -1) {
          str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1);
        }
      }
      //正则替换
      str = str.replace(/[^\d^\.]+/g, ""); // 保留数字和⼩数点

      str = str.replace(/^\D*([0-9]\d*\.?\d{0,10})?.*$/, "$1"); // ⼩数点后只能输 10 位

      return str;
    },
    cleanSubmit(){
      this.form = JSON.parse(JSON.stringify(this.initForm))
      this.quotation_type = []
      if(this.filterCond.length){
        this.filterCond = []
        this.$emit('filterCond',[])
      }
    },
    onSubmit() {
      console.log('submit!',this.form);
      let filterCond = []
      for (const formKey in this.form) {
        if(this.form[formKey] instanceof Array){
            if(this.form[formKey].length){
              filterCond.push({
                filter:"in",
                columnName:formKey,
                columnValue:this.form[formKey]
              })
            }
        }else if(formKey=='create_time'){
          if(this.form[formKey].start){
            filterCond.push({
              filter: "ge",
              columnName: formKey,
              columnValue: this.form[formKey].start
            })
          }
          if(this.form[formKey].end){
            filterCond.push({
              filter: "le",
              columnName: formKey,
              columnValue: this.form[formKey].end
            })
          }
        } else if (formKey=='clue_update_time') {
          if (this.form.clue_update_time) {
            const value = this.form.clue_update_time
            const columnVal = value.split('-')[0]
            const filterVal = value.split('-')[1]
            filterCond.push({
              filter: filterVal,
              columnName:"clue_update_time",
              columnValue: columnVal
            })
          }
        }else{
          if(this.form[formKey]){
            filterCond.push({
              filter:"eq",
              columnName:formKey,
              columnValue:this.form[formKey]
            })
          }
        }
      }
      this.filterCond = filterCond
      this.$emit('filterCond', filterCond)
    },

    async addClientAction(){
      this.$refs.clientNameRef.blur()
      this.addClientDialogVisble = true
    },

    async addClueAction(){
      this.loading = true
      if(this.action=='add'){
        let res = await addClue(this.form)
        if(res.respCode&&res.respCode=='000000'){
          console.log('addClueAction',res)
          this.$message.success(res.respMsg)
          this.$emit('refresh')
          this.$nextTick(()=>{
            this.loading = false
            this.form = JSON.parse(JSON.stringify(this.initForm))
            this.$emit('input',false)
          })
        }else{
          this.$message.error(res.respMsg)
        }
      }else{
        let editList = []
        for (let formKey in this.form) {
          if(this.form[formKey]!==this.editForm[formKey]){
            editList.push({
              key:formKey,
              old_value:this.editForm[formKey],
              new_value:this.form[formKey]
            })
          }
        }
        let postData = {
          clue_id:this.form.clue_id,
          edit_info:editList
        }
        console.log('editClueInfo',postData)
        let res = await editClueInfo(postData)
        if(res.respCode&&res.respCode=='000000'){
          console.log('editClueInfo',res)
          this.$message.success(res.respMsg)
          this.$emit('refresh')
          this.$nextTick(()=>{
            this.loading = false
            this.$emit('input',false)
          })
        }else{
          this.$message.error(res.respMsg)
        }
        //  editClueInfo
      }

    },

    /**
     * 获取客户列表
     * @param content
     */
    async getClientNameList(){
      let pData = {
      }
      let res = await getClueOption(pData)
      // console.log('getClientNameList',res)
      if(res.respCode&&res.respCode=='000000'){
        let ClueOption = res.respData
        this.ClueOption = ClueOption
        this.client_name_options = this.ClueOption.client_name
      }else{
        this.$message.error(res.respMsg)
      }
    },

    quotationTypeChange(e){
      this.form.quotation_type = e.map(arr=>arr[1])
      console.log('quotationTypeChange',e,this.form.quotation_type)

    },
    mutuliSelectChange(e,formKey){
      if(e instanceof Array){
        if(e.indexOf('all')!==-1){
          this.form[formKey] = []
        }
      }else{
        if(e=='all'){
          this.form[formKey] = ""
        }
      }

    },

    /**
     * 根据客户名称获取组别
     * @param client_name
     * @returns {Promise<void>}
     */
    async getSecondaryDeptByClientName(client_name){
      let pData = {
        index:"client_name",
        client_name:client_name
      }
      let res = await getClueOption(pData)
      console.log('getSecondaryDeptByClientName',res,pData)
      if(res.respCode&&res.respCode=='000000'){
        this.form.secondary_dept = res.respData[0].secondary_dept
      }else{
        this.$message.error(res.respMsg)
      }
    },

    /**
     * 根据计价类型获取业务类型
     * @param client_name
     * @returns {Promise<void>}
     */
    getBusinessTypeByQuoationType(quotation_type) {
      let quotation_type_map_item = this.ClueOption.quotation_type_map.find(function (item) {
        return item.quotation_type === quotation_type;
      })
      if (quotation_type_map_item) {
        this.form.business_type = quotation_type_map_item.business_type
        console.log('getBusinessTypeByQuoationType', this.form.business_type, quotation_type_map_item)
      }
    },

    refresh(content){
      this.refreshId +=1
    }
  }
}
</script>

<style lang="scss">
.main-table-filter{
  .el-cascader__tags{
    //height:24px;
  }

  .el-input--mini .el-input__inner{
    //height:28px !important;
  }
  .el-cascader__search-input{
    //height:14px !important;
    //font-size:12px !important;
    //position: relative;
    //top:3px;
  }
  .form-title{
    font-size: 12px;
  }
  .el-form-item{
    margin-top: 16px;
    margin-bottom:0px;
  }
  .el-tabs__item.is-active .el-icon-close::before {
    content: "";
    line-height: 33px;
    color: #FFFFFF;
    // margin-left: 15px;
    position: absolute;
    top: 0px;
    right: 14px;
    //background-color: green;
  }
  .el-icon-close::before {
    content: "";
    line-height: unset !important;
    color: #8E93A8;
    position: unset !important;
    top: unset !important;
    right: unset !important;
  }
  .el-icon-close {
    display: inline-block;
    width: 15px;
    //background-color: #3C903F;
  }
  .el-tabs__item.is-top{
    height: 33px;
    line-height: 33px;
  }
  .el-tabs__nav-scroll{
    height: 33px;
  }
  .el-tag__close.el-icon-close{
    right:unset !important;
    margin-left:3px;
    top:0 !important;
  }
  .el-tag__close{
    margin-top:unset !important;
  }
}


  .form-select{
    width: 100%;
  }

</style>
